// export const entrance = "고객님께서 티켓 발권 센터에 입장하셨습니다.";
export const entrance = "You have entered the ticketing center.";
export const natasha = [
    // natasha speaking 1
    //  ": 안녕하세요 고객님,<br />대왕트래블에 오신 것을 환영합니다.",
    ": Hello vacationer,<br />welcome to Big King Travel.",
    //  ": 저는 고객님의 담당 가이드, 나타샤 입니다.",
    ": I am your guide, Natasha.",
    //natasha speaking 2
    //  ": 나타샤는 칭첸 사람입니다.<br />한국 사람 아니에요.<br />한국말은 사장님이 가르쳐줬습니다.",
    ": I’m from Ching Chen,<br />so my English is not so good.<br />So I will do tour in Ching Chen language.",
    ": But there is a English subtitles,<br />so please no worry.",
    // ": 티켓 발권에 앞서, <br />두 가지 주의사항 안내드립니다.",
    ": Before I give you a ticket,<br />you must know two things.",
    // ': <span class="jh-yellow">[1]</span> 저희 투어는 <span class="text-red-blink">성인들만 이용 가능</span>하시며, <br />미성년자 출입시 책임을 지지 않습니다.',
    ': <span class="jh-yellow">[1]</span> Our tour is for <span class="text-red-blink">adult only.</span><br />Don\'t ask me why.',
    // ': <span class="jh-yellow">[2]</span> 투어 <span class="text-red-blink"/>총 소요시간은 15분</span>이며, <br />관람 중단시 재입장은 불가합니다.',
    ': <span class="jh-yellow">[2]</span> The tour is <span class="text-red-blink"/>15 minutes.</span><br />If you leave, you cannot re-enter.',
    // ": 위 내용을 모두 확인하셨습니까?",
    ": Do you understand this?",
    // natasha speaking 3
    // ": 감사합니다. <br />현재 고객님의 티켓이 발권되고 있습니다. ",
    ":  Thank you.<br />We are printing your ticket.",
    // ": 위의 티켓을 클릭하여 입장해주십시오.<br />칭쳰에서 뵙겠습니다!",
    ":  Click the ticket above and board the cruise ship.",
];
// export const response = "네, 확인하였습니다.";
export const response = "Yes, I understand.";
//# sourceMappingURL=texts.js.map